export default function (can, cannot) {
  can("list", "User");

  can("view-menu", "User");
  can("view-menu", "Group");
}
